import Faq from '@/api/faq'
export default {
  name: 'faq',
  components: {
  },
  data () {
    return {
      faqs: [],
      activeNames: []
    }
  },
  mounted () {
    const data = { name: 'faq' }
    Faq.getFaq(data).then((res) => {
      // console.log(res.result)
      this.faqs = res.result
      this.faqs.forEach((faq, index) => {
        faq.listdesc = faq.desc.split('\n')
        this.activeNames.push(index)
      })
    }).catch((err) => {
      console.log(err)
    })
  },
  methods: {
    handleChange (val) {
      console.log(val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/faq/index.js